import script from "./PortfolioRingChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioRingChart.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioRingChart.vue?vue&type=style&index=0&id=035914e7&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035914e7"]])

export default __exports__